<template>
  <section class="content-plans-register">
    <Breadcrumb :links="links" :data="this.dataProps" />
    <form class="content-plans-register-form" @submit.prevent="handleSubmit()">
      <div class="row">
        <div class="col-12">
          <div class="content-input-default">
            <input
              type="text"
              name="name"
              v-model="dayOfTheWeek.name"
              value=""
              placeholder="Nome"
              required
            />
          </div>
        </div>
        <div class="col-12">
          <button class="btn-green">Salvar</button>
        </div>
      </div>
    </form>
  </section>
</template>

<script>
import Breadcrumb from "@/components/breadcrumb/Index";
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      links: [
        {
          name: "Profissionais",
          routerName: "Professional",
        },
        {
          name: "Novo dia da semana",
          routerName: "RegisterDayOfTheWeek",
        },
      ],
      dayOfTheWeek: {
        name: "",
      },
      dayOfTheWeekParams: this.$route.params,
      selectedCategory: "",
      dataProps: { module: "Professional" },
    };
  },
  computed: {
    ...mapGetters({
      user: "User/user",
      daysOfTheWeekData: "Professional/daysOfTheWeek",
    }),
  },
  components: {
    Breadcrumb,
  },
  methods: {
    ...mapActions("Professional", [
      "registerDayOfTheWeek",
      "consultDaysOfTheWeek",
      "setDataDefault",
    ]),
    async handleSubmit() {
      let message = this.dayOfTheWeek?.id
        ? "Dia da semana editado com sucesso!"
        : "Dia da semana cadastrado com sucesso!";

      await this.registerDayOfTheWeek(this.dayOfTheWeek);
      this.$router.push({ name: "ListDaysOfTheWeek" });
      this.$swal.fire({
        icon: "success",
        html: message,
      });
    },
  },
  async mounted() {
    if (
      this.dayOfTheWeekParams &&
      Object.keys(this.dayOfTheWeekParams).length > 0
    ) {
      await this.consultDaysOfTheWeek(this.dayOfTheWeekParams);
      this.dataProps = {
        name: this.daysOfTheWeekData.name,
        id: this.dayOfTheWeekParams.id,
        module: "Professional",
        type: "DaysOfTheWeek",
      };
      this.dayOfTheWeek = this.daysOfTheWeekData;
      this.links[1].name = this.dayOfTheWeek.name;
    }
  },
};
</script>

<style lang="scss" scoped>
.content-plans-register {
  padding-bottom: 50px;
}
.content-input-default {
  textarea {
    min-height: 250px;
  }
}
.btn-green {
  margin-top: 100px;
  @media (max-width: 991px) {
    margin-top: 50px;
  }
}
</style>
